module.exports = __webpack_public_path__ + "img/live-tv-icon_superlive.c054d294.svg";